module.exports = __webpack_public_path__ + "img/testerPhoto.8591221e.png";